import { BrowserService } from '../service/browser.service';
import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UtilityService } from '../service/utility.service';

@Component({
  selector: 'app-awareness',
  templateUrl: './awareness.page.html',
  styleUrls: ['./awareness.page.scss'],
})
export class AwarenessPage implements OnInit {
  activated: any;
  data : any = []

  constructor(
    private http: HttpClient,
    private browser: BrowserService,
    private utility : UtilityService
  ) {
    this.activated = "hindi";
  }

  ngOnInit() {
    this.fetchData()
  }


  info() {
    this.utility.goInfoTab();
  }

  loadLink(link) {
    this.browser.openLink(link);
  }

  fetchData() {
    return new Promise((resolve, reject) => {
      this.http.get("assets/awarenessData.json").subscribe(res => {
        this.data = res;
      })
    });
  }

  openHindi(){
    let hindi = document.getElementById('hindi');
    let english = document.getElementById('english');
    hindi.style.display = "block";
    english.style.display = "none";
  }

  openEng(){
    let hindi = document.getElementById('hindi');
    let english = document.getElementById('english');
    hindi.style.display = "none";
    english.style.display = "block";
  }
}
